// @flow
// Util function for extracting an action name when tracking link clicks
const INLINE_LINK_ACTION = 'inline_link';
const BUTTON_ACTION = 'button';
const PDF_LINK_ACTION = 'pdf_link';
const PDF_REGEX = /\.pdf$|\.pdf#|\.pdf\?/i;

export const extractLinkAction = (anchor: HTMLAnchorElement) => {
  const linkClass = anchor.className.toLowerCase();
  const linkHref = anchor.getAttribute('href');

  if (PDF_REGEX.test(anchor.href)) {
    return PDF_LINK_ACTION;
  }

  if (linkClass.indexOf('button') !== -1 || linkHref === '#') {
    return BUTTON_ACTION;
  }

  return INLINE_LINK_ACTION;
};
